import { BadRequestError } from '@cian/valuation-utils-component';

import {
  IMappers,
  IGetFiltersWebRequest,
  IGetFiltersWebResponse,
} from '../../../repositories/price-estimator/v3/get-filters-web';

export const createMapper = (parameters: IGetFiltersWebRequest): IMappers<TMappedResponse200, TMappedResponse400> => ({
  200: response => response,
  400: ({ message, errors }) =>
    new BadRequestError({
      message: message as string,
      domain: 'getPreciseFilters.ts',
      details: { errors: JSON.stringify(errors), parameters: JSON.stringify(parameters) },
    }),
});

export type TMappedResponse200 = IGetFiltersWebResponse;
export type TMappedResponse400 = BadRequestError;

export type TPreciseFiltersResponseMapped = TMappedResponse200 | TMappedResponse400;
